import { useState } from 'react'

import { getAPIClient } from 'api/axios'

interface RemoveRecurrenceCouponResponse {
  message: string
  quota_returned: boolean
  reason?: string
}

interface UseRemoveRecurrenceCouponReturn {
  removeRecurrenceCoupon: (
    recurrenceUuid: string
  ) => Promise<RemoveRecurrenceCouponResponse>
  loading: boolean
  error: string | null
}

export const useRemoveRecurrenceCoupon =
  (): UseRemoveRecurrenceCouponReturn => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const client = getAPIClient()

    const removeRecurrenceCoupon = async (
      recurrenceUuid: string
    ): Promise<RemoveRecurrenceCouponResponse> => {
      setLoading(true)
      setError(null)

      try {
        const response = await client.delete(
          `/v1/recurrences/${recurrenceUuid}/coupon`
        )
        return response.data
      } catch (err: any) {
        const message =
          err?.response?.data?.message || 'Erro ao remover cupom da recorrência'
        setError(message)
        throw message
      } finally {
        setLoading(false)
      }
    }

    return { removeRecurrenceCoupon, loading, error }
  }
